import PropTypes from "prop-types";

import { CreateNewTagModalLayout } from "./CreateNewTagModal.layout";
import { useCreateNewTagModal } from "./useCreateNewTagModal";

const CreateNewTagModal = ({
  onClose,
  allTags,
  setNewTag,
  featureFlags,
  tagTypesConfig,
  initialDisplayValue,
  initialTagType,
  initialAttributes,
  entityId,
}) => {
  const form = useCreateNewTagModal({
    onClose,
    allTags,
    setNewTag,
    initialDisplayValue,
    initialTagType,
    initialAttributes,
    entityId,
  });

  return (
    <CreateNewTagModalLayout
      onClose={onClose}
      featureFlags={featureFlags}
      tagTypesConfig={tagTypesConfig}
      {...form}
    />
  );
};

CreateNewTagModal.propTypes = {
  onClose: PropTypes.func,
  setNewTag: PropTypes.func,
  allTags: PropTypes.array,
  featureFlags: PropTypes.object,
  tagTypesConfig: PropTypes.array,
  initialDisplayValue: PropTypes.string,
  initialTagType: PropTypes.object,
  initialAttributes: PropTypes.object,
  entityId: PropTypes.string,
};

export default CreateNewTagModal;
